import ResetPasswordModalHeader from './ResetPasswordModalHeader';

export default ResetPasswordModalHeader;